import { useQuery } from '@tanstack/react-query';
import moment from 'moment';
import cacheQueryKeys from 'resources/ReactQuery/queryCacheKeys';

import { fetchTimeSlots, TimeSlotDict } from '../api/api';

type Props = {
  orgUuid: string;
  dateFrom: Date;
  dateTo: Date;
  serviceUuid: string;
  onSuccess?: (data?: TimeSlotDict) => void;
};

const formatDay = (day: Date) => moment(day).format('YYYY-MM-DD');

export const useTimeSlotsDict = ({ orgUuid, dateFrom, dateTo, serviceUuid, onSuccess }: Props) => {
  return useQuery(
    [cacheQueryKeys.OnlineBookingTimeSlots],
    () => fetchTimeSlots(orgUuid, formatDay(dateFrom), formatDay(dateTo), serviceUuid),
    {
      staleTime: 0,
      select: (data) => {
        return Object.fromEntries(data.data.map((day) => [day.date, day.time_slots]));
      },
      onSuccess,
    }
  );
};
